import { useMutation } from '@apollo/react-hooks'
import { IPutAvailabilities } from '@components/Modal/AvailabilityModal/interface'
import WarningModal from '@components/Modal/WarningModal'
import { MERGE_AVAILABILITIES, REPLACE_AVAILABILITIES } from '@mutations/instructorAvailability'
import React from 'react'
import { useIntl } from 'react-intl'
import { IAvailabilityResponse, IUnAvailabilityResponse } from './interface'

interface IPOverwriteModal {
  open: boolean
  hasConflicts: boolean
  isOverwritable: boolean
  payload: IPutAvailabilities
  getPayload: () => IPutAvailabilities
  onClose: () => void
  onSaving: () => void
  onSaved: (success: boolean) => void
}

const OverwriteModal: React.FC<IPOverwriteModal> = ({
  open,
  hasConflicts,
  isOverwritable,
  payload,
  getPayload,
  onClose,
  onSaving,
  onSaved,
}) => {
  const intl = useIntl()
  const onCompleted = (data: IAvailabilityResponse & IUnAvailabilityResponse) =>
    onSaved((data?.mergeAvailabilities || data?.replaceAvailabilities)?.ServiceStatus?.Success || false)
  const onError = () => onSaved(false)

  const [mergeAvailabilities] = useMutation<IUnAvailabilityResponse, IPutAvailabilities>(MERGE_AVAILABILITIES, {
    onCompleted,
    onError,
  })

  const [replaceAvailabilities] = useMutation<IUnAvailabilityResponse, IPutAvailabilities>(REPLACE_AVAILABILITIES, {
    onCompleted,
    onError,
  })

  return (
    <WarningModal
      open={open}
      onClose={() => onClose()}
      onCancel={() => {
        onSaving()
        mergeAvailabilities({
          variables: getPayload ? getPayload() : payload,
        })
      }}
      cancelLabel={intl.formatMessage({ id: 'Merge' })}
      onProceed={() => {
        onSaving()
        replaceAvailabilities({
          variables: getPayload ? getPayload() : payload,
        })
      }}
      proceedLabel={intl.formatMessage({ id: 'Replace' })}
      noButtons={hasConflicts}
      title={intl.formatMessage({
        id: isOverwritable ? 'Conflict schedules found' : 'Conflict found',
      })}
      subtitle={intl.formatMessage({
        id: isOverwritable
          ? 'Resolve conflicts by selecting an option below'
          : 'You cannot have overlapping schedules, please check your start and end dates',
      })}
    />
  )
}

export default OverwriteModal
